var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/compose/components/schedule-button.tsx";
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { addSchedule, removeSchedule } from 'soapbox/actions/compose';
import { useAppDispatch, useCompose } from 'soapbox/hooks';
import ComposeFormButton from './compose-form-button';
const messages = defineMessages({
  add_schedule: {
    "id": "schedule_button.add_schedule",
    "defaultMessage": "Schedule post for later"
  },
  remove_schedule: {
    "id": "schedule_button.remove_schedule",
    "defaultMessage": "Post immediately"
  }
});

const ScheduleButton = _ref => {
  let {
    composeId,
    disabled
  } = _ref;
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const compose = useCompose(composeId);
  const active = !!compose.schedule;
  const unavailable = !!compose.id;

  const handleClick = () => {
    if (active) {
      dispatch(removeSchedule(composeId));
    } else {
      dispatch(addSchedule(composeId));
    }
  };

  if (unavailable) {
    return null;
  }

  return /*#__PURE__*/React.createElement(ComposeFormButton, {
    icon: require('@tabler/icons/calendar-stats.svg'),
    title: intl.formatMessage(active ? messages.remove_schedule : messages.add_schedule),
    active: active,
    disabled: disabled,
    onClick: handleClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 5
    }
  });
};

export default ScheduleButton;